<template>
  <header class="header-login">
    <div class="container">
      <div class="flex items-center justify-between py-4">
        <router-link to="/" class="flex items-center space-x-4 hover:opacity-80 transition-opacity">
          <div class="w-12 h-12 bg-white rounded-full flex items-center justify-center">
            <img src="../assets/logo1.png" alt="吉林省软件行业协会" class="w-full h-full object-contain">
          </div>
          <h1 class="text-gray-800 text-xl font-bold">吉林省软件行业协会</h1>
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'LoginHeader'
}
</script>

<style scoped>
.header-login {
  background-color: white;
  box-shadow: 0 4px 20px rgba(75, 96, 231, 0.1);
}

a {
  text-decoration: none;
}
</style>
